<template>
  <div class="contentPage orderDetailPay" v-if="displayPage">
    <!-- <van-nav-bar title="求付款" left-arrow @click-left="onClickLeft" /> -->
    <div class="contentBox">
      <van-form class="formBox">
        <van-field readonly>
          <template #label>
            <div class="label">订单编号</div>
          </template>
          <template #input>
            <div class="text">{{ orderInfo.orderCode }}</div>
          </template>
        </van-field>
        <van-field readonly>
          <template #label>
            <div class="label">代付金额</div>
          </template>
          <template #input>
            <div class="text color">
              ￥
              <span>{{ orderInfo.payableAmount.toFixed(2) }}</span>
            </div>
          </template>
        </van-field>
        <van-field readonly v-if="orderInfo && orderInfo.expireTime">
          <template #label>
            <div class="label">剩余支付时间</div>
          </template>
          <template #input>
            <van-count-down
              v-if="time"
              class="time text"
              :time="time"
              format="HH 小时： mm 分： ss 秒"
              @finish="finish"
            />
          </template>
        </van-field>
      </van-form>
      <div class="tipsBox">
        <h3>支付说明</h3>
        <p>1、付款前务必和好友再次确认，避免是欺诈行为；</p>
        <p>2、如果发生退款，钱将原路退款至您的付款账户</p>
      </div>
      <div class="footer">
        <van-button round block type="danger" @click="goPay">
          立即支付
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Form, Field, CountDown, Button } from 'vant';
import { getMainOrderByParentId, checkPayStatus } from '@/api/orderDetailPay';
export default {
  components: {
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [Button.name]: Button,
  },
  data() {
    return {
      id: '',
      orderInfo: {},
      displayPage: false,
      time: '',
    };
  },
  computed: {},
  created() {
    this.id = this.$route.query.id;
    this.init();
  },
  mounted() {},
  watch: {},
  methods: {
    init() {
      getMainOrderByParentId({ parentOrderId: this.id }).then((res) => {
        if (res.data) {
          const { data } = res;
          if (!data.invalid) {
            this.displayPage = true;
            this.time = new Date(data.expireTime) - new Date().getTime();
            this.orderInfo = data;
          } else {
            this.$router.replace({ path: 'errorTips' });
          }
        }
      });
    },
    onClickLeft() {
      window.WeixinJSBridge.call('closeWindow');
    },
    finish() {
      // Toast('倒计时结束');
      this.$router.replace({ path: 'errorTips' });
    },
    goPay() {
      checkPayStatus({ parentOrderId: this.id }).then((res) => {
        if (res.data) {
          this.$router.replace({ path: 'errorTips' });
        } else {
          this.$router.push({
            name: 'payInit',
            query: { id: this.id, type: 'ORDER', payShare: 1 },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.orderDetailPay {
  /deep/ .contentBox {
    padding: 0 16px;
    box-sizing: border-box;

    .formBox {
      border-radius: 6px;
      background: #fff;
      margin: 18px 0;
      padding: 10px 12px 20px;
      overflow: hidden;

      .van-cell {
        padding: 0;
        margin-bottom: 8px;

        &::after {
          border: 0;
        }
      }

      .van-field__label {
        width: 7em;
      }

      .label {
        font-size: 14px;
        color: #787878;
      }

      .text {
        font-size: 14px;

        &.color {
          font-size: 16px;
          color: $themeColor;
        }
      }

      .time {
        color: $themeColor;
      }
    }

    .tipsBox {
      color: #000;
      font-size: 12px;
    }

    .footer {
      width: 100%;
      background: #fff;
      padding: 12px 30px 35px;
      box-sizing: border-box;
      position: fixed;
      left: 0;
      bottom: 0;

      .van-button--danger {
        height: 36px;
        font-size: 18px;
      }
    }
  }
}
</style>
